import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/noto-sans-sc';
import { App } from './App';
import './styles.css';

const isDeployPage = new URLSearchParams(window.location.search).get('deploy') === 'kava';
const DeployApp = lazy(() => import('./DeployApp').then((module) => ({ default: module.DeployApp })));

createRoot(document.getElementById('root')!).render(
  <StrictMode>{isDeployPage ? <Suspense fallback={<main className="deploy-loading">正在加载部署控制台…</main>}><DeployApp /></Suspense> : <App />}</StrictMode>
);
